import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';
import 'rxjs/add/operator/toPromise';


@Injectable()
export class DocketService {
    private headers = new Headers({'Content-Type': 'application/json'});
    private api_url_get_docket_history = './api/server.php?cmd=SEARCH_DOCKETS';
    private api_url_get_docket_details = './api/server.php?cmd=DOCKETS_ABSTRACT';
    private api_url_modify_docket = './api/server.php?cmd=MODIFY_DOCKET';
    private api_url_cancel_modification = './api/server.php?cmd=CANCEL_MODIFICATION_DOCKET';
    private api_url_delete_article = './api/server.php?cmd=DELETE_ARTICLE_DOCKET';
    private api_url_validate_modification = './api/server.php?cmd=VALIDATE_DOCKET_MODIFICATION';
    private api_url_modify_this_docket_session = './api/server.php?cmd=MODIFY_SESSION_DOCKET';
    private api_url_validate_modification_docket_session = './api/server.php?cmd=VALIDATE_SESSION_MODIFICATION_DOCKET';

    constructor(private http: Http) {}


    SearchDocket(docket_name: string, operation: string, date: string): Promise<Object> {
        return this.http.get(this.api_url_get_docket_history + '&name=' + docket_name + '&operation=' + operation + '&date=' + date)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }
    GetDocketDetails(id_docket: string): Promise<Object> {
        return this.http.get(this.api_url_get_docket_details + '&id_docket=' + id_docket)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ModifyDocket(): Promise<Object> {
        return this.http.get(this.api_url_modify_docket)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    DeleteArticle(article_index: string, total_price: string): Promise<Object> {
        return this.http.get(this.api_url_delete_article + '&article_index=' + article_index + '&total_price=' + total_price)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ValidateMofidication(remark: string): Promise<Object> {
        return this.http.get(this.api_url_validate_modification + '&remark=' + remark)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    CancelModification(): Promise<Object> {
        return this.http.get(this.api_url_cancel_modification)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    EditDocketSession(index: number): Promise<Object> {
        return this.http.get(this.api_url_modify_this_docket_session + '&index=' + index)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ValidateEditDocketSession(docket: any): Promise<Object> {
        return this.http.get(this.api_url_validate_modification_docket_session
            + '&index=' + docket.article_index +
            '&quantity=' + docket.new_quantity
            + '&serial_number=' + docket.new_serial
            + '&id_article=' + docket.id_article
            + '&id_lot=' + docket.id_lot
            + '&remark=' + docket.remark
            )

            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// ./src/app/docket.service.ts